/* eslint-disable */
import React from 'react';
import { Check } from '../../components/ui/check/Check';
import { Option } from '../../components/ui/check/Option';
import { useStore } from '../../store/store';
import { useNav } from '../../hooks/nav';
import Analytics from '@web-solutions/module-analytics';
import { t } from '@web-solutions/module-localization';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';

function Page() {
  const foodMythsSweets = useStore((state) => state.foodMythsSweets);
  const setFoodMythsSweets = useStore((state) => state.setFoodMythsSweets);
  const { onNext, onPrev, currentIndex } = useNav();

  return (
    <div className={'page'}>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className={'wrapper-info'}>
        <Title tag='h2'>{t('onboarding.foodMythsSweets.title')}</Title>
      </div>

      <div className={'controls'}>
        <Check
          defaultValue={foodMythsSweets}
          onChange={(value) => {
            setFoodMythsSweets(value);
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'food-myths-sweets',
              answer: value,
            });
            onNext();
          }}
        >
          <Option value={'Yes, absolutely'}>
            <span>🍬</span> {t('onboarding.foodMythsSweets.options.yesAbsolutely')}
          </Option>
          <Option value={"No, everything's fine in moderation"}>
            <span>😋</span> {t('onboarding.foodMythsSweets.options.moderationOk')}
          </Option>
        </Check>
      </div>
    </div>
  );
}

export default Page;
